import { disputeDeflectionSchema } from "@redotech/redo-dispute-db-schema/dispute-deflection-definition";
import * as z from "zod";

// Single RESOLVE (deflection) request for the detail page; null when not found /
// not this merchant's. Returns the FULL row incl `responseBody` so the detail
// page can render exactly what we sent on the merchant's behalf.
// `matchedOrderShopifyId` is the matched order's Shopify id (resolved from the
// stored Mongo `_id`), so the detail page can deep-link into Shopify admin;
// null when there was no match or the order can no longer be loaded.
export const getDeflection = {
  name: "getDeflection" as const,
  input: z.object({ deflectionId: z.coerce.bigint() }),
  output: z.object({
    deflection: z.nullable(disputeDeflectionSchema),
    matchedOrderShopifyId: z.nullable(z.string()),
  }),
};
